/*global google*/
import React, { useState, useEffect } from 'react';
import AssignTargetPDMC from '../NewAdminPanel/AssignTarget/AssignTargetPDMC';
import AssignTargetOP from '../NewAdminPanel/AssignTarget/AssignTargetOP';
import AssignTargetOS from './AssignTarget/AssignTargetOS';
import AssignTargetMNT from './AssignTarget/AssignTargetMNT';



function AssignTarget() {
    const [schemeCode, setSchemeCode] = useState(null);

    useEffect(() => {
        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        setSchemeCode(schemeCode);
    }, []);
    
    const renderComponent = () => {
        switch (schemeCode) {
            case "1":
                return <AssignTargetPDMC />;
            case "14":
                return <AssignTargetPDMC />;
            case "5":
                return <AssignTargetOS />;
            case "16":
                // return <AssignTargetPDMC />;
                return <AssignTargetMNT />;
            default:
                return <AssignTargetPDMC />;
        }
    };
    
    return (

        <>
            {renderComponent()}
        </>
    );
}

export default AssignTarget;